import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Cross1Icon } from '@radix-ui/react-icons';
import { ElevatedButton, IconButton } from '@producer/ui-kit';

import { ToolBar, Tools } from '../../../components/toolbar/toolbar';
import { TaskList } from './tasks-list';
import { uiStore } from '../../../core/stores/ui-store';
import { CreateTaskModal } from './create-task.modal';
import { PagePlaceholder } from '../../../components/page-placeholder/page-placeholder';
import { ClipboardTick } from '../../../components/icons';
import { taskGroupingStore } from '../../../core/stores/task-store';
import { openModal } from '../../../core/modal/open-modal';
import { TaskDetail } from './task-detail';

import { Step, Task } from '../../../app/entities';

import styles from './task.panel.module.scss';

interface TaskPanelProps {
  insideStep?: boolean;
  targetId: string;
}

export const TaskPanel: React.FC<TaskPanelProps> = observer(
  ({ targetId, insideStep = false }: TaskPanelProps) => {
    const step = Step.getOne(targetId) as Step;

    /**
     * If a task is selected and should be displayed in the list
     */
    const [taskId, setTaskId] = useState(null);

    const task = Task.getOne(taskId) as Task;

    const openCreateModal = () => {
      openModal(CreateTaskModal, {
        title: 'Create task',
        project: step.project,
        defaultValues: {
          stepId: step?._id,
          dueDate: step?.dueDate,
        }
      });
    }

    return (
      <div className={styles.container} data-insideStep={!!insideStep}>
        <ToolBar title={step.name} onBack={taskId ? () => setTaskId(null) : undefined}>
          <Tools>
            <ElevatedButton icon={<ClipboardTick />} text="Create task" onClick={openCreateModal} />
            <IconButton icon={<Cross1Icon />} onClick={() => uiStore.closeTaskPanel()} />
          </Tools>
        </ToolBar>

        {step.tasks.length === 0 ? (
          <PagePlaceholder
            description="No tasks in this step."
            backgroundImgUrl="/images/order-from-chaos.svg"
          />
        ) : task ? (
          <div className={styles.detail}>
            <TaskDetail task={task} />
          </div>
        ) : (
          <TaskList
            key={taskGroupingStore.groupingKey}
            tasks={step.tasks || []}
            onSelectTask={(taskId) => setTaskId(taskId)}
            taskLevel="step"
            defaultValues={{
              stepId: step?._id,
              dueDate: step?.dueDate,
            }}
          />
        )}
      </div>
    );
  },
);
